import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Dialog, SelectField, TextField } from '@unite-us/ui';
import { callbacks, hooks } from '../../../config/api';
import { PrimaryButton } from '../../common/TailwindComponents';
import { INSURANCE_STATUSES } from './constants';
export var DisenrollModal = function DisenrollModal(_ref) {
  var _data$data$data, _data$data, _context;
  var insurance = _ref.insurance,
    open = _ref.open,
    onClose = _ref.onClose;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    disenrollReason = _useState2[0],
    setDisenrollReason = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    note = _useState4[0],
    setNote = _useState4[1];
  var disenrollModalRef = useRef(null);
  useEffect(function () {
    if (open) {
      disenrollModalRef.current.openDialog();
    }
  }, [open]);
  var _hooks$useFind = hooks.useFind('enrollment_disenroll_reasons', {
      state: 'active',
      plan: insurance.plan.id
    }),
    data = _hooks$useFind.data;
  var disenrollReasons = (_data$data$data = data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.data) !== null && _data$data$data !== void 0 ? _data$data$data : [];
  var onCloseInternal = function onCloseInternal() {
    setDisenrollReason(undefined);
    setNote(undefined);
    disenrollModalRef.current.closeDialog();
    onClose();
  };
  var invalidateQueries = hooks.useInvalidateQueries();
  var _hooks$useCreateRecor = hooks.useCreateRecord('enrollment_request', {
      mutationConfig: {
        onError: function onError() {
          return callbacks.toast.error('Something went wrong.');
        },
        onSuccess: function onSuccess() {
          callbacks.toast.success("Request for disenrollment from ".concat(insurance.plan.name, " social care coverage plan sent to Plan Administrator."));
          onCloseInternal();
        },
        onSettled: function onSettled() {
          invalidateQueries('enrollment_request');
          invalidateQueries('insurance');
          callbacks.fetchRecentUpdates();
        }
      }
    }),
    createEnrollmentRequest = _hooks$useCreateRecor.createRecord;
  var _hooks$useUpdateRecor = hooks.useUpdateRecord('insurance', {
      mutationConfig: {
        onError: function onError() {
          return callbacks.toast.error('Something went wrong.');
        },
        onSuccess: function onSuccess() {
          callbacks.toast.success("Client no longer enrolled in ".concat(insurance.plan.name, " social care coverage plan."));
          callbacks.fetchRecentUpdates();
          onCloseInternal();
        },
        onSettled: function onSettled() {
          invalidateQueries('insurance');
        }
      }
    }),
    updateInsurance = _hooks$useUpdateRecor.updateRecord;
  var onRequestDisenroll = function onRequestDisenroll() {
    createEnrollmentRequest({
      request_type: 'disenroll',
      person: insurance.person.id,
      plan: insurance.plan.id,
      insurance: insurance.id,
      enrollment_disenroll_reason: disenrollReason,
      disenroll_note: note
    });
  };
  var onDisenroll = function onDisenroll() {
    updateInsurance(insurance.id, {
      insurance_status: INSURANCE_STATUSES.not_enrolled
    });
  };
  var clientName = _concatInstanceProperty(_context = "".concat(insurance.person.first_name, " ")).call(_context, insurance.person.last_name);
  var enrollmentRequired = !!insurance.plan.enrollment_required;
  return /*#__PURE__*/React.createElement(Dialog, {
    id: "disenroll-modal",
    className: "sub-dialog",
    ref: disenrollModalRef,
    title: "Disenroll from social care coverage",
    modal: true,
    onRequestClose: onCloseInternal,
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      className: " action-item py-2 px-4 flex border border-solid rounded border-dark-pale-blue bg-white text-dark-blue ",
      onClick: onCloseInternal,
      type: "button"
    }, "Cancel"), enrollmentRequired ? /*#__PURE__*/React.createElement(PrimaryButton, {
      className: " action-item px-4 border-validation-red bg-validation-red hover:bg-dark-red hover:border-dark-red ",
      onClick: onRequestDisenroll,
      label: "Request Disenrollment",
      disabled: !disenrollReason
    }) : /*#__PURE__*/React.createElement(PrimaryButton, {
      className: " action-item px-4 border-validation-red bg-validation-red hover:bg-dark-red hover:border-dark-red ",
      onClick: onDisenroll,
      label: "Disenroll"
    }))
  }, /*#__PURE__*/React.createElement(React.Fragment, null, enrollmentRequired ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "text-sm font-heavy-font"
  }, "This social care coverage plan requires payer approval for disenrollment."), /*#__PURE__*/React.createElement("p", {
    className: "text-sm"
  }, "To disenroll ", /*#__PURE__*/React.createElement("strong", null, clientName), " from ", /*#__PURE__*/React.createElement("strong", {
    className: "text-red"
  }, insurance.plan.name), ", a request will be sent to the payer."), /*#__PURE__*/React.createElement(SelectField, {
    id: "disenroll_reason",
    className: "pt-4 text-brand-blue relative w-8/12",
    label: "DISENROLLMENT REASON",
    options: _mapInstanceProperty(disenrollReasons).call(disenrollReasons, function (reason) {
      return {
        label: reason.display_name,
        value: reason.id
      };
    }),
    value: disenrollReason,
    onChange: setDisenrollReason,
    placeholder: "Choose code",
    required: true,
    truncateOptions: false
  }), /*#__PURE__*/React.createElement(TextField, {
    label: "Note",
    labelClassName: "ui-form-field__label text-brand-blue text-13px",
    id: "disenroll_note",
    placeholder: "Provide any additional details to describe the request for disenrollment",
    value: note,
    onChange: function onChange(event) {
      return setNote(event.target.value);
    },
    style: {
      error: {
        height: 0
      }
    }
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "text-sm"
  }, "You are about to disenroll ", /*#__PURE__*/React.createElement("strong", null, clientName), " from ", /*#__PURE__*/React.createElement("strong", {
    className: "text-red"
  }, insurance.plan.name), "."), /*#__PURE__*/React.createElement("p", {
    className: "text-sm"
  }, "Are you sure you want to disenroll?"))));
};
DisenrollModal.propTypes = {
  insurance: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
//# sourceMappingURL=DisenrollModal.js.map